export type TargetPriority = 'high' | 'normal' | 'none';

const HIGH_PRIORITY_KEYWORDS = [
  'critical', 'urgent', 'deadline', 'release', 'launch', 'milestone', 'demo',
  'must', 'required', 'essential', 'blocker', 'important', 'asap'
];

export function getTargetPriority(target?: string): TargetPriority {
  if (!target) return 'none';
  
  const lowerTarget = target.toLowerCase();
  const hasHighPriorityKeyword = HIGH_PRIORITY_KEYWORDS.some(keyword => 
    lowerTarget.includes(keyword)
  );
  
  return hasHighPriorityKeyword ? 'high' : 'normal';
}

